module.exports = __webpack_public_path__ + "media/agronomic.45aa36c5.mp4";